/* ==========================================================================

   CALNIDO — comportements homepage

   Aucune librairie. ~40 lignes. Respecte prefers-reduced-motion.

   ========================================================================== */

(function () {

  'use strict';



  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;



  /* --- Apparition au scroll ------------------------------------------- */

  function initReveal() {

    var items = document.querySelectorAll('.tn-reveal');

    if (!items.length) return;



    if (reduced || !('IntersectionObserver' in window)) {

      items.forEach(function (el) { el.classList.add('is-in'); });

      return;

    }



    var io = new IntersectionObserver(function (entries) {

      entries.forEach(function (entry, i) {

        if (!entry.isIntersecting) return;

        var el = entry.target;

        // cascade légère à l'intérieur d'un même groupe

        var delay = parseInt(el.dataset.tnDelay || (i * 80), 10);

        setTimeout(function () { el.classList.add('is-in'); }, delay);

        io.unobserve(el);

      });

    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });



    items.forEach(function (el) { io.observe(el); });

  }



  /* --- Barre CTA fixe mobile ------------------------------------------ */

  /* Apparaît une fois le hero dépassé, disparaît sur le CTA final

     pour ne pas doubler le même bouton. */

  function initSticky() {

    var bar = document.querySelector('.tn-sticky');

    if (!bar) return;



    var hero = document.querySelector('[data-tn-hero]');

    var last = document.querySelector('[data-tn-final-cta]');

    var pastHero = false;

    var atFinal = false;



    function sync() {

      bar.classList.toggle('is-visible', pastHero && !atFinal);

    }



    if ('IntersectionObserver' in window) {

      if (hero) {

        new IntersectionObserver(function (e) {

          pastHero = !e[0].isIntersecting;

          sync();

        }, { threshold: 0 }).observe(hero);

      } else {

        pastHero = true;

      }



      if (last) {

        new IntersectionObserver(function (e) {

          atFinal = e[0].isIntersecting;

          sync();

        }, { threshold: 0.2 }).observe(last);

      }

      sync();

    } else {

      bar.classList.add('is-visible');

    }

  }



  /* --- Film héro : version mobile 9:16 (le film complet sur fond flouté,

         demande Fares 01/09 « pas adapté format mobile ») ----------------- */

  function initHeroSource() {

    var vid = document.querySelector('video.tn-hero__bg');

    if (!vid || vid.dataset.tnSrcDone) return;

    var m = vid.getAttribute('data-tn-mobile-src');

    if (m && window.matchMedia('(max-width: 749px)').matches) {

      vid.dataset.tnSrcDone = '1';

      var p = vid.getAttribute('data-tn-mobile-poster');

      if (p) vid.poster = p;

      vid.src = m;

      vid.load();

      var play = vid.play();

      if (play && play.catch) play.catch(function () {});

    }

  }



  /* --- Bouton son du film héro ---------------------------------------- */

  function initHeroSound() {

    var btn = document.querySelector('[data-tn-hero-sound]');

    var vid = document.querySelector('video.tn-hero__bg');

    if (!btn || !vid) { if (btn) btn.hidden = true; return; }

    // icônes SVG monochromes (l'émoji système est bleu — demande Fares 01/09)

    var HP = '<path d="M3 6h2.6L9.5 3v10L5.6 10H3z" fill="currentColor"/>';

    var ON = '<svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true">' + HP +

      '<path d="M11.3 5.6a3.4 3.4 0 0 1 0 4.8M13 4a5.8 5.8 0 0 1 0 8" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" fill="none"/></svg>';

    var OFF = '<svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true">' + HP +

      '<path d="M11.2 6.2l3.6 3.6M14.8 6.2l-3.6 3.6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" fill="none"/></svg>';

    btn.addEventListener('click', function () {

      vid.muted = !vid.muted;

      btn.setAttribute('aria-pressed', String(!vid.muted));

      btn.innerHTML = vid.muted ? ON + 'Activer le son' : OFF + 'Couper le son';

      if (!vid.muted && vid.paused) vid.play();

    });

  }



  /* --- Affordance des tableaux qui débordent --------------------------- */

  /* Deux signaux (demandes Fares 01/09 — pastille « Glisser » retirée, « ça

     fait trop ») :

     1. auto-démo : le tableau glisse tout seul (aller-retour) à sa 1re

        apparition à l'écran — le mouvement est l'indication la plus claire ;

     2. chevron circulaire pulsant au milieu du bord droit de la carte,

        effacé dès que l'utilisateur a glissé lui-même. */

  function initTableSwipe() {

    document.querySelectorAll('.tn-table-scroll').forEach(function (sc) {

      if (sc.dataset.tnSwipe) return;

      sc.dataset.tnSwipe = '1';



      var host = sc.parentElement || sc;

      host.classList.add('tn-swipe-host');



      var edge = document.createElement('span');

      edge.className = 'tn-swipe-edge';

      edge.setAttribute('aria-hidden', 'true');

      edge.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M4 3l5 5-5 5M9 3l5 5-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      host.appendChild(edge);



      function sync() {

        var on = sc.scrollWidth - sc.clientWidth > 12;

        edge.classList.toggle('is-on', on);

        host.classList.toggle('has-pill', on);

      }



      var nudging = false;

      function done() {

        edge.classList.add('is-done');

      }

      sc.addEventListener('scroll', function () {

        if (!nudging && sc.scrollLeft > 24) done();

      }, { passive: true });



      // auto-démo une seule fois, quand le tableau est bien visible

      if (!reduced && 'IntersectionObserver' in window) {

        var io = new IntersectionObserver(function (entries) {

          if (!entries[0].isIntersecting) return;

          io.disconnect();

          if (sc.scrollLeft > 5 || sc.scrollWidth - sc.clientWidth <= 12) return;

          nudging = true;

          sc.scrollTo({ left: 72, behavior: 'smooth' });

          setTimeout(function () { sc.scrollTo({ left: 0, behavior: 'smooth' }); }, 700);

          setTimeout(function () { nudging = false; }, 1600);

        }, { threshold: 0.35 });

        io.observe(sc);

      }



      window.addEventListener('resize', sync);

      sync();

    });

  }



  function init() { initReveal(); initSticky(); initHeroSource(); initHeroSound(); initTableSwipe(); }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init);

  } else {

    init();

  }



  // Le thème réinjecte le DOM dans l'éditeur : on relance.

  document.addEventListener('shopify:section:load', init);

})();



/* ==========================================================================

   Galerie produit filtrée par coloris.

   Convention : une photo du coloris noir a « noir » dans son texte alt

   (alts posés par les CSV d'import). Blanc sélectionné → photos noires

   masquées, et inversement. Sans mélange des deux dans la galerie, on ne

   masque rien.

   ========================================================================== */

(function () {

  'use strict';



  var NOIR = /noir/i;



  function couleur() {

    var radios = document.querySelectorAll('input[type=radio]:checked');

    for (var i = 0; i < radios.length; i++) {

      if (radios[i].value === 'Noir') return 'noir';

      if (radios[i].value === 'Blanc') return 'blanc';

    }

    return null;

  }



  function estNoir(el) {

    var img = el.tagName === 'IMG' ? el : el.querySelector('img');

    return !!(img && NOIR.test(img.alt || ''));

  }



  function toggle(el, hide) {

    if (hide) { el.setAttribute('data-tn-hidden', ''); }

    else { el.removeAttribute('data-tn-hidden'); }

  }



  function apply() {

    var c = couleur();

    var mg = document.querySelector('media-gallery');

    if (!c || !mg) return;



    var grid = mg.querySelectorAll('.media-gallery__grid > li');

    var slides = mg.querySelectorAll('slideshow-container slideshow-slide');

    var dots = mg.querySelectorAll('slideshow-controls .slideshow-control');



    var pool = grid.length ? grid : slides;

    if (!pool.length) return;

    var noirs = 0;

    pool.forEach(function (el) { if (estNoir(el)) noirs++; });

    var mixte = noirs > 0 && noirs < pool.length;



    grid.forEach(function (li) {

      toggle(li, mixte && (estNoir(li) !== (c === 'noir')));

    });

    slides.forEach(function (s, i) {

      var hide = mixte && (estNoir(s) !== (c === 'noir'));

      toggle(s, hide);

      if (dots[i]) toggle(dots[i].closest('li') || dots[i], hide);

    });

    mg.querySelectorAll('zoom-dialog img').forEach(function (img) {

      var item = img.closest('li') || img;

      toggle(item, mixte && (NOIR.test(img.alt || '') !== (c === 'noir')));

    });

  }



  var t;

  function sched() { clearTimeout(t); t = setTimeout(apply, 80); }



  document.addEventListener('change', function (e) {

    if (e.target && e.target.type === 'radio') sched();

  }, true);



  // Horizon re-rend la galerie au changement de variante : on ré-applique.

  new MutationObserver(sched).observe(document.documentElement, { childList: true, subtree: true });



  sched();

})();

